import { IApplication } from '../interface/i-application';

/**
 * Builds candidate entities.
 */
export class ApplicationFactory {
  new(props?: Partial<IApplication>): IApplication {
    return {
      id: 0,
      candidateReceiveNotifications: false,
      myNumberCardSubmissionAccepted: false,
      residenceCardRequirementAccepted: false,
      newMessagesFromAgent: false,
      ...props,
    };
  }
}
